import { render, staticRenderFns } from "./appointment-grid.vue?vue&type=template&id=490a506f&scoped=true"
import script from "./appointment-grid.vue?vue&type=script&lang=js"
export * from "./appointment-grid.vue?vue&type=script&lang=js"
import style0 from "./appointment-grid.vue?vue&type=style&index=0&id=490a506f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490a506f",
  null
  
)

export default component.exports